<mat-icon  [ngClass]="validationClass"> {{ icon }} </mat-icon>
